module.exports = __webpack_public_path__ + "img/Tessellate34.1eff2f21.jpg";